import { PurposeType } from '@common/types/enum';
import { App, ConsentUpdate, Purpose } from '@common/types/model';

const diffAppsAsPayload = (targetApp: App, activeApps: App[]) => {
  const changedConsents : ConsentUpdate[] = [];
  // The app selected by the customer
  const activeApp = activeApps.find((app) => app.name === targetApp.name && app.consentId === targetApp.consentId);
  if (!activeApp) throw new Error(`App "${targetApp.name}" was not found in the active purpose data`);

  // Only add it if the status is different
  if (targetApp.granted !== activeApp.granted) {
    changedConsents.push({ id: activeApp.consentId, status: activeApp.granted ? 'active' : 'revoked' });
  }
  return changedConsents;
};

//
// Compares two purposes and returns only those with different "granted" status between the two purposes.
// The format returned can be used for api4p endpoints like postConsentsUpdateList
//
export const diffPurposesAsPayload = (initialPurpose: Purpose, activePurpose : Purpose) : ConsentUpdate[] => {
  let changedConsents : ConsentUpdate[] = [];

  // identifier bound purposes
  if (initialPurpose.purposeType === PurposeType.identifier_bound) {
    initialPurpose.subscriptions!.forEach((initialSubscription) => {
      // The subscription selected by the customer
      const activeSubscription = activePurpose.subscriptions!.find((sub) => sub.msisdn === initialSubscription.msisdn);

      if (!activeSubscription) throw new Error(`Subscription "${initialSubscription.msisdn}" was not found in the active purpose data`);

      initialSubscription.apps.forEach((initialApp) => {
        changedConsents = changedConsents.concat(diffAppsAsPayload(initialApp, activeSubscription.apps));
      });
    });
  } else if (initialPurpose.purposeType === PurposeType.user_bound) {
    initialPurpose.apps!.forEach((initialApp) => {
      changedConsents = changedConsents.concat(diffAppsAsPayload(initialApp, activePurpose.apps!));
    });
  }

  return changedConsents;
};
